var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.02 11.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e85d27;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.51,6.27c-1.24-.64-2.49-.68-3.77-.12-.01-.14-.02-.28-.04-.41,0-.06-.03-.12-.06-.16-1.03-1.31-2.07-2.62-3.1-3.93-.04-.05-.09-.07-.15-.07-.2,0-.39,0-.59,0C.35,1.58,0,1.24,0,.8,0,.36.33.02.77,0c.06,0,.12,0,.18,0C4.69,0,8.42,0,12.16,0c.49,0,.77.31.84.6.12.49-.24.97-.75.98-.18,0-.36,0-.54,0-.07,0-.11.02-.15.08-.88,1.33-1.76,2.66-2.64,3.99-.14.21-.28.42-.41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.51,6.6c.41,0,.81.06,1.19.2.51.18.98.45,1.36.85.25.26.48.54.65.87.18.34.31.7.38,1.08.02.1.03.21,0,.3-.07.18-.22.34-.49.31-.19-.02-.36-.16-.39-.36-.1-.66-.4-1.22-.9-1.66-.48-.43-1.05-.64-1.69-.67-.44-.02-.86.08-1.26.25-.16.07-.3.17-.44.27-.61.45-.97,1.05-1.09,1.8-.03.2-.23.4-.51.37-.22-.02-.39-.2-.39-.42,0-.32.1-.63.22-.92.11-.25.25-.48.38-.71.07-.12.17-.24.27-.34.26-.25.52-.51.85-.7.58-.34,1.19-.51,1.86-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.93,10.73c-.18-.15-.23-.36-.21-.58.04-.49.52-.81.96-.7.04,0,.1-.01.12-.04.2-.19.4-.4.6-.59.14-.13.35-.12.49.01.13.12.15.35.02.49-.18.2-.38.38-.57.56-.06.05-.08.11-.07.18.07.33-.05.61-.32.8-.27.19-.56.2-.85.04-.07-.04-.12-.1-.18-.15,0,0,0,0,0,0,0-.01-.01-.03-.02-.04,0,0,0,0,0,0Zm.07-.02h0s0,.01,0,0c.01,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.93,10.73s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.94,10.77s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6,10.72s.02,0,0,0c0,.01,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6,10.71s0,0,0,0c0,0,0,0,0,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/Meter.6b17abf10f56e2c1584c6ac38921b8ef.svg";
export { ForwardRef as ReactComponent };